import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";

interface DashboardLayoutProps {
  children: ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-background">
      <Header
        onNewProject={() => navigate("/new-project")}
        onViewProjects={() => navigate("/projects")}
      />

      <main className="container mx-auto px-4 py-6">{children}</main>
    </div>
  );
}
